export default __webpack_public_path__ + "static/hero-video-ad4ce47f9c11a09ac2cecd0203861c61.mp4";